import api from "@/interceptors/axios";

const API_PREFIX = "api/social";
const ADMIN_PREFIX = "api/admin/social";

function pageParams(cursor, perPage) {
  const params = { per_page: perPage };
  if (cursor) params.cursor = cursor;
  return params;
}

function postFormData({ content = "", images = [], keptImageIds = null }) {
  const form = new FormData();
  form.append("content", content == null ? "" : String(content));

  if (Array.isArray(keptImageIds)) {
    form.append("kept_image_ids", JSON.stringify(keptImageIds));
  }

  images.forEach((image) => form.append("images[]", image));
  return form;
}

function multipartConfig() {
  return { headers: { "Content-Type": undefined } };
}

export const socialErrorMessage = (error, fallback = "Não foi possível concluir a ação.") => {
  const response = error?.response?.data;
  const validation = response?.errors;
  const firstField = validation && Object.keys(validation)[0];
  const firstMessage = firstField && Array.isArray(validation[firstField])
    ? validation[firstField][0]
    : null;

  return firstMessage || response?.message || fallback;
};

export const socialMediaUrl = (path) => {
  if (!path || /^https?:\/\//i.test(path) || path.startsWith("data:") || path.startsWith("blob:")) {
    return path || "";
  }

  const apiBase = process.env.VUE_APP_API_URL || window.location.origin;
  return new URL(path.replace(/^\//, ""), apiBase).toString();
};

export const getSocialFeed = (cursor = null, perPage = 10) =>
  api.get(`${API_PREFIX}/feed`, { params: pageParams(cursor, perPage) });

export const createSocialPost = (payload) =>
  api.post(`${API_PREFIX}/posts`, postFormData(payload), multipartConfig());

export const updateSocialPost = (postId, payload) =>
  api.post(`${API_PREFIX}/posts/${postId}/update`, postFormData(payload), multipartConfig());

export const deleteSocialPost = (postId) => api.delete(`${API_PREFIX}/posts/${postId}`);

export const likeSocialPost = (postId) => api.post(`${API_PREFIX}/posts/${postId}/likes`);
export const unlikeSocialPost = (postId) => api.delete(`${API_PREFIX}/posts/${postId}/likes`);

export const getSavedSocialPosts = (cursor = null, perPage = 10) =>
  api.get(`${API_PREFIX}/saved`, { params: pageParams(cursor, perPage) });
export const saveSocialPost = (postId) => api.post(`${API_PREFIX}/posts/${postId}/saves`);
export const unsaveSocialPost = (postId) => api.delete(`${API_PREFIX}/posts/${postId}/saves`);

export const getSocialComments = (postId, cursor = null, perPage = 10) =>
  api.get(`${API_PREFIX}/posts/${postId}/comments`, { params: pageParams(cursor, perPage) });
export const createSocialComment = (postId, content) =>
  api.post(`${API_PREFIX}/posts/${postId}/comments`, { content });
export const updateSocialComment = (commentId, content) =>
  api.put(`${API_PREFIX}/comments/${commentId}`, { content });
export const deleteSocialComment = (commentId) => api.delete(`${API_PREFIX}/comments/${commentId}`);

export const getSocialStories = (cursor = null, perPage = 20) =>
  api.get(`${API_PREFIX}/stories`, { params: pageParams(cursor, perPage) });
export const createSocialStory = (image) => {
  const form = new FormData();
  form.append("image", image);
  return api.post(`${API_PREFIX}/stories`, form, multipartConfig());
};
export const markSocialStoryViewed = (storyId) => api.post(`${API_PREFIX}/stories/${storyId}/views`);
export const deleteSocialStory = (storyId) => api.delete(`${API_PREFIX}/stories/${storyId}`);

export const getSocialModerationPosts = (cursor = null, perPage = 20) =>
  api.get(`${ADMIN_PREFIX}/posts`, { params: pageParams(cursor, perPage) });
export const getSocialModerationComments = (cursor = null, perPage = 20) =>
  api.get(`${ADMIN_PREFIX}/comments`, { params: pageParams(cursor, perPage) });
export const getSocialModerationStories = (cursor = null, perPage = 20) =>
  api.get(`${ADMIN_PREFIX}/stories`, { params: pageParams(cursor, perPage) });
